module.exports = __webpack_public_path__ + "img/A58A0514.1adac285.jpg";